module.exports = __webpack_public_path__ + "img/graph.3aec9a39.svg";